import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
require('../../assets/css/gallery.css')
import aws from 'aws-sdk';
import { Button, Card, CardActionArea, CardMedia, Typography, CardActions, IconButton } from '@material-ui/core';
import { useSelector } from 'react-redux';
import RefreshIcon from '@material-ui/icons/Refresh';
import LoadingHook from './LoadingHook';

export default function S3List_Hook({ selectedImg }) {


    const { user } = useSelector(state => state.reducer_user)

    const [imgArr, setImgArr] = useState([])
    const [isLoading, setIsLoading] = useState()
    const path = 'https://shopping-cart-x.s3.eu-central-1.amazonaws.com/'

    const [lastSelectedCardName, setLastSelectedCardName] = useState()



    const deletedImg = (img) => {
        console.log('delete img:', img)
        alert('delete not implemented yet')
    }


    const loadGallery2 = async () => {

        try {
            setIsLoading(true)

            aws.config.setPromisesDependency();
            aws.config.update({
                bucketName: process.env.REACT_APP_S3_BUCKET_NAME,
                dirName: process.env.REACT_APP_S3_FOLDER_NAME,//+ user._id + '/', /* optional */
                region: process.env.REACT_APP_S3_REGION,
                accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
                secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY
            })
            console.log('user._id:', user._id)
            const s3 = new aws.S3();
            const data = await s3.listObjectsV2({
                Bucket: process.env.REACT_APP_S3_BUCKET_NAME, 
                Prefix: 'seller-media/60f896f2a7fe9f22d4fcb412/',
            }).promise()


            // Key: "seller-media/60f896f2a7fe9f22d4fcb412/login.png"
            // https://shopping-cart-x.s3.eu-central-1.amazonaws.com/seller-media/60f896f2a7fe9f22d4fcb412/aliexpress.png
            console.log('data:', data)
            console.log('data.Contents:', data.Contents)
            setImgArr(data.Contents)
            setIsLoading(false)


        } catch (error) {
            console.log('error:', error)
            setIsLoading(false)
        }

    }


    const imageSelect = (parentName, imgKey) => {
        // console.log('imgKey:', imgKey)
        // console.log('parentName:', parentName)

        let card;
        if (lastSelectedCardName) {
            card = document.getElementsByName(lastSelectedCardName)
            if (card) {
                card[0].style.border = '0 none';
            }
        }

        card = document.getElementsByName(parentName)
        if (card) {
            card[0].style.border = '1px solid'
        }

        // selected card
        setLastSelectedCardName(parentName)
        // selected image name

        // console.log("imgKey.split('seller-media/')[1]:", imgKey.split('/')[2])
        // selectedImg(imgKey.split('seller-media/')[1])
        selectedImg(imgKey.split('/')[2])

    }


    return (
        <div className='gal-root'>
            <Typography gutterBottom variant='h4' color="textSecondary" className='gal-header'>
                Personal Gallery
            </Typography>
            <div className='gallery-box'>
                {
                    imgArr && (imgArr.map((img, i) => (

                        <Card className="card" key={img.Key} name={'card_id' + i}>


                            <CardActionArea>
                                <CardMedia
                                    component="img"
                                    alt="product image"
                                    className='cardImg'
                                    image={path + img.Key}
                                />
                                {/* <CardContent className='cardTxt' >
                            <Typography variant="p" component="p" color="textSecondary">
                                the image name
                            </Typography>
                        </CardContent> */}
                            </CardActionArea>
                            <CardActions className='cardBtn'>
                                <Button size="small" color="primary"
                                    onClick={() => imageSelect('card_id' + i, img.Key)}
                                // onClick={() => selectedImg(img.Key.split('seller-media/')[1])}
                                >
                                    select
                                </Button>
                                <Button size="small" color="primary"
                                    onClick={() => deletedImg(img.Key)}
                                >
                                    delete
                                </Button>
                            </CardActions>
                        </Card>
                    )))
                }





                {/* {imgArr && (
                    imgArr.map((img) => (
                        <div className="responsive" key={img.Key} >
                            <div className="gallery">
                                <a target="_blank" href="img_5terre.jpg">
                                    <img src={path + img.Key} alt="Cinque Terre" width="600" height="400" />
                                </a>
                                <div className="desc">Add a description of the image here</div>
                            </div>
                        </div>
                    ))
                )} */}

            </div>


            <div className='loadingBox'>
                <IconButton color="primary" aria-label="upload picture" component="span"
                    onClick={loadGallery2}
                >
                    <RefreshIcon />
                </IconButton>

                {isLoading && <LoadingHook isSmall />}
            </div>

        </div>
    )
}

S3List_Hook.propTypes = {
    selectedImg: PropTypes.func,
}